
import { defineComponent } from "vue";
import TextLabel from "./Label.vue";
import SkeletonLoader from "./SkeletonLoader.vue";

export default defineComponent({
    name: "ArtworkCard",
    components: { TextLabel, SkeletonLoader },
    props: {
        imgSrc: {
            type: String,
        },
        artworkId: {
            type: String,
            required: true,
        },
        big: {
            type: Boolean,
            default: false,
        },
        fullHeight: {
            type: Boolean,
            default: false,
        },
    },
});
